import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bm-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CoreComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
